import { useQuery } from '@tanstack/react-query';

import { CabinEventClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const cabinEventClient = new CabinEventClient(apiBaseUrl);

function useGetCabinEventApprovalList() {
  return useQuery({
    queryKey: [queryKeys.CabinEvent.ApprovalList],
    queryFn: () => cabinEventClient.getApprovalList(),
  });
}

export default useGetCabinEventApprovalList;
